// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "22f75f4f" + "." + "cc3530eb7a02533a" + ".js";
};